import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormPhoneNumber from '../general-input-form/FormPhoneNumber'
import FormSwitchInput from '../general-input-form/FormSwitchInput'
import FormSelectInput from '../general-input-form/FormSelectInput'

const AppForm = ({
  values,
  handleChange,
  errors,
  countryOptions,
  country,
  setCountry,
  handleSelectCountry,
  genderOptions,
  gender,
  handleSelectGender,
  isCreated = false,
  roleOptions,
  role,
  handleSelectRole,
  isShowRole = false
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='user_first_name'
          name='user_first_name'
          colSize='6'
          inputLabel='First Name'
          className='mb-3'
          placeholder='Enter first name...'
          value={values.user_first_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.user_first_name}
          invalid={errors.user_first_name}
        />
        <FormTextInput 
          id='user_last_name'
          name='user_last_name'
          colSize='6'
          inputLabel='Last Name'
          className='mb-3'
          placeholder='Enter last name...'
          value={values.user_last_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.user_last_name}
          invalid={errors.user_last_name}
        />
        <FormTextInput 
          id='user_email'
          name='user_email'
          colSize='6'
          inputLabel='Email Address'
          className='mb-3'
          placeholder='Enter email address...'
          value={values.user_email}
          handleTextInput={handleChange}
          feedbackInvalid={errors.user_email}
          invalid={errors.user_email}
        />
        <FormTextInput 
          id='user_username'
          name='user_username'
          colSize='6'
          inputLabel='Username'
          className='mb-3'
          placeholder='Enter username...'
          value={values.user_username}
          handleTextInput={handleChange}
          feedbackInvalid={errors.user_username}
          invalid={errors.user_username}
        />
        <FormSelectInput 
          id='user_gender'
          name='user_gender'
          colSize='6'
          inputLabel='Gender'
          className='mb-3'
          selectOptions={genderOptions}
          value={gender}
          handleSelectInput={handleSelectGender}
          feedbackInvalid={errors.user_gender}
          invalid={errors.user_gender}
          disabled={false}
          placeholder='Please select gender...'
        />
        <FormPhoneNumber
          colSize='6'
          inputLabel='Phone Number'
          placeholder='Enter phone number...'
          className='mb-3'
          countryOptions={countryOptions}
          country={country}
          setCountry={setCountry}
          value={values}
          handlePhoneNumber={handleChange}
          handlePhoneCountry={handleSelectCountry}
          errors={errors}
        />
        {
          isShowRole && (
            <FormSelectInput 
              id='user_role_id'
              name='user_role_id'
              colSize='6'
              inputLabel='Role'
              className='mb-3'
              selectOptions={roleOptions}
              value={role}
              handleSelectInput={handleSelectRole}
              feedbackInvalid={errors.user_role_id}
              invalid={errors.user_role_id}
              disabled={false}
              placeholder='Please select role...'
            />
          )
        }
        {
          !isCreated && (
            <FormSwitchInput 
              id='is_active'
              name='is_active'
              label={values.is_active ? 'active' : 'inactive'}
              colSize='3'
              inputLabel='Status'
              className='mb-3'
              handleSwitch={handleChange}
              value={values.is_active}
              invalid={errors?.is_active}
            />
          )
        }
      </CRow>
    </>
  )
}

export default AppForm